import React from 'react';
import { analytics } from './services/googleAnalytics.ts';

interface ContactModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const ContactModal: React.FC<ContactModalProps> = ({ isOpen, onClose }) => {

  const handleEmailClick = () => {
    analytics.trackEvent('direct_email_clicked', { location: 'contact_modal' });
    window.location.href = 'mailto:admin@bkofuel.com?subject=Contact depuis BamakoFuel';
  };

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[9999]"
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
    >
      <div className="bg-white rounded-lg w-full max-w-lg max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-xl font-semibold text-gray-900">
              📧 Contactez-nous
            </h2>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 text-2xl"
            >
              ×
            </button>
          </div>

          {/* Contact info section */}
          <div className="text-center">
            <div className="mb-6 p-6 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg border border-blue-200">
              <div className="mb-4">
                <span className="text-4xl">💬</span>
              </div>

              <h3 className="font-semibold text-blue-900 mb-3 text-lg">Notre équipe est là pour vous aider !</h3>

              <p className="text-blue-800 mb-6">
                Envoyez-nous un email et nous vous répondrons dans les plus brefs délais.
              </p>

              <button
                onClick={handleEmailClick}
                className="inline-flex items-center space-x-3 bg-white hover:bg-blue-50 text-blue-700 font-semibold py-3 px-6 rounded-lg shadow-sm border border-blue-200 transition-all hover:shadow-md"
              >
                <span className="text-xl">✉️</span>
                <span>admin@bkofuel.com</span>
              </button>

              <p className="text-xs text-blue-600 mt-4">
                Cliquez pour ouvrir votre application mail
              </p>
            </div>

            <button
              onClick={onClose}
              className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium py-2 px-6 rounded-lg transition-colors"
            >
              Fermer
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactModal;